/**
 * @generated SignedSource<<129d635e8d86229a650ffcd2056487d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type identityprovidertype = "AXON" | "OIDC" | "SAML" | "UNKNOWN" | "%future added value";
export type login_type = "AXON" | "ONE_TIME_PASSWORD" | "SSO" | "UNKNOWN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SsoProviderLoginTypeSelection_idpData$data = {
  readonly identityProviderConfigurations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly providerType: identityprovidertype;
        readonly uuid: string;
      } | null;
    } | null>;
  } | null;
  readonly loginTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly authEnabled: boolean;
        readonly identityProviderConfiguration: {
          readonly id: string;
          readonly name: string;
          readonly providerType: identityprovidertype;
          readonly uuid: string;
        } | null;
        readonly loginType: login_type;
      } | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "SsoProviderLoginTypeSelection_idpData";
};
export type SsoProviderLoginTypeSelection_idpData$key = {
  readonly " $data"?: SsoProviderLoginTypeSelection_idpData$data;
  readonly " $fragmentSpreads": FragmentRefs<"SsoProviderLoginTypeSelection_idpData">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "uuid",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "providerType",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SsoProviderLoginTypeSelection_idpData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IdentityProviderConfigurationConnection",
      "kind": "LinkedField",
      "name": "identityProviderConfigurations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IdentityProviderConfigurationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IdentityProviderConfiguration",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orgDefault",
          "value": true
        }
      ],
      "concreteType": "LoginTypesConnection",
      "kind": "LinkedField",
      "name": "loginTypes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LoginTypesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LoginTypes",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "loginType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "authEnabled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IdentityProviderConfiguration",
                  "kind": "LinkedField",
                  "name": "identityProviderConfiguration",
                  "plural": false,
                  "selections": (v0/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "loginTypes(orgDefault:true)"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "13d2392db4b8684362057fe3b110e1d9";

export default node;
